import React from 'react';
import { FormattedNumber } from 'react-intl';

const isNullOrUndefined = (value: any): value is null | undefined => {
    return value === null || value === undefined;
};

const isString = (value: any): value is string => {
    return typeof value === 'string';
};

export function NullableFormattedNumber(props: { value?: string | undefined | null | number }) {
    if (isNullOrUndefined(props.value)) {
        return null;
    }
    const numberValue = isString(props.value) ? parseFloat(props.value) : props.value;
    return <FormattedNumber value={numberValue} />;
}
